module.exports = __webpack_public_path__ + "img/LOGO_NUBBO.f582b69b.png";